export default "__VITE_ASSET__32634234__"